import React from 'react';
import {getElementId, useWebformElement,} from 'gatsby-drupal-webform/dist/utils';
import WebformElementWrapper from './WebformElementWrapper';

export const WebformInput = ({element, error}) => {
  const id = getElementId(element.name);
  const [inputProps, settings] = useWebformElement(element, {
    className: 'vl-input-field vl-input-field--block',
    name: element.name,
    type: element.type,
    id,
  });
  if (element.type === 'hidden') {
    return <input {...inputProps} />;
  }

  const getRequiredErrorMessage = () => {
    let message = 'Dit veld is verplicht';

    element.attributes.forEach((attribute) => {
      if (attribute.name === '#required_error') {
        message = attribute.value;
        return;
      }
    });

    return message;
  };

  const errorProps = inputProps.required ? {
    'data-vl-error-placeholder': `${element.name}-error`,
    'data-vl-error-message': getRequiredErrorMessage(),
    'data-vl-error-class': 'vl-input-field--error',
  } : {};

  return (
    <WebformElementWrapper
      labelClassName="vl-form__label vl-form__label--light"
      settings={settings}
      error={error}
      labelFor={id}
    >
      <input {...inputProps} {...errorProps}/>
      <div className="vl-form__error" data-vl-error-id={`${element.name}-error`}></div>
    </WebformElementWrapper>
  );
};

export default WebformInput;
